import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  PanesComponent as Panes,
  WebinarInfoPaneComponent as WebinarInfoPane,
  WebinarUserInfoPaneComponent as WebinarUserInfoPane,
} from '../../../sharedLegacy/components'
import { useInterval } from '../../../sharedLegacy/hooks'

import AudienceFoyerLoader from './AudienceFoyerLoaderComponent'

import { useAudienceAppState } from '../../providers/AudienceAppStateProvider'
import usePreconnect from '../../hooks/usePreconnect'

/**
 * Container
 */
const Container = styled.div`
  align-items: center;
  background-attachment: fixed;
  background-color: #535353;
  background-image: url(/resources/um/graphics/webinars/foyer-bg.png);
  background-position: center center;
  background-size: cover;
  display: flex;
  height: 100vh;
  justify-content: center;
`

/**
 * PanesContainer
 */
const PanesContainer = styled.div`
  background-color: #ffffff;
  border-radius: 2px;
  height: 460px;
  padding: 16px;
  width: 750px;
`

const getWebinarStatus = (isDraft, liveStatus) => {
  if (!isDraft) return liveStatus
  return 'draft'
}

const AudienceFoyerPanes = {
  WebinarInfo: 0,
  UserInfo: 1,
}

/**
 * AudienceFoyerComponent
 */
const AudienceFoyerComponent = ({ renderOptions, onError }) => {
  const { liveId, liveToken } = useAudienceAppState()
  const { load, webinar } = usePreconnect(liveId, liveToken, onError)
  const isFoyerDataLoaded = !!webinar

  useEffect(() => {
    load()
  }, [load])

  useInterval(() => {
    load()
  }, 5000)

  const numberOfPanes = Object.keys(AudienceFoyerPanes).length

  const title = webinar?.name || ''
  const isDraft = webinar?.draft_p
  const liveStatus = webinar?.live_status
  const status = getWebinarStatus(isDraft, liveStatus) || 'draft'
  const description = webinar?.description_html || ''
  const speakers = webinar?.speakers || []
  const liveDate = new Date(webinar?.live_date)
  const name = window.localStorage?.comment_name ?? 'Friend'
  const link = webinar?.link

  return (
    <Container>
      <AudienceFoyerLoader isLoading={!isFoyerDataLoaded}>
        <PanesContainer>
          <Panes
            numberOfPanes={numberOfPanes}
            direction="row"
            renderPane={(index) => {
              if (index === AudienceFoyerPanes.WebinarInfo) {
                return (
                  <WebinarInfoPane
                    title={title}
                    description={description}
                    status={status}
                    liveDate={liveDate}
                    speakers={speakers}
                  />
                )
              }

              if (index === AudienceFoyerPanes.UserInfo) {
                return (
                  <WebinarUserInfoPane name={name}>
                    {renderOptions && renderOptions(name, link)}
                  </WebinarUserInfoPane>
                )
              }

              return null
            }}
          />
        </PanesContainer>
      </AudienceFoyerLoader>
    </Container>
  )
}

AudienceFoyerComponent.propTypes = {
  onError: PropTypes.func.isRequired,
  renderOptions: PropTypes.func,
}

export default AudienceFoyerComponent
